import React, { useEffect, useState } from "react";
import "./Turntable.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faFileLines } from "@fortawesome/free-solid-svg-icons";
import No_data from "../Common/No_data/No_data";
import { Link } from "react-router-dom";
import Turntable_spin_wheel from "./Turntable_spin_wheel/Turntable_spin_wheel";
import Turntable_banner from "./Turntable_banner/Turntable_banner";
import { useDispatch, useSelector } from "react-redux";
import { GetAllTurntableHistory, GetTurntableDash } from "../../features/spin/Slice";
import { formatAmount, formatNotifDate } from "../../utils/common";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Turntable() {
  const [isSpinning, setIsSpinning] = useState(false);


  const dispatch = useDispatch()


  const handleSpin = () => {
    if (isSpinning) return;
    setIsSpinning(true);
    // Add logic for rotation degrees here
    setTimeout(() => setIsSpinning(false), 4000);
  };

  const spin = useSelector((state) => state.spin.dashboard);
  const spinHistory = useSelector((state) => state.spin);

  useEffect(() => { dispatch(GetTurntableDash()) }, [dispatch]);


  const fetch = async (page = 1) => {

    await dispatch(GetAllTurntableHistory({
      page: page
    }));

  }

  useEffect(() => { fetch(1) }, [dispatch])

  const handlePageChange = async (page) => {
    fetch(page)
  };

  return (
    <section className="Turntable">
      <Common_white_header headingText={"Wheel Spin"} />

      <Turntable_banner />
      <div className="container">

        {/* Section 1: Stats Area */}
        <div className="stats-section">
          <div className="heading_bg_holder">
            <div className="img_holder">
              <img
                src="/assets/images/Invitation_Reward_Rules/heading_bg.png"
                className="bg_img"
                alt="bg"
              />
            </div>
            <div className="rules_title">
              <p>Today</p>
            </div>
          </div>

          <div className="stat-card">
            <span>Total Recharge</span>
            <div className="amount-badge">
              {formatAmount(spin?.total_deposite_today || 0)} <i className="refresh-icon"><FontAwesomeIcon style={{
                cursor: "pointer"
              }} icon={faArrowsRotate} onClick={() => window.location.reload()} /></i>
            </div>
          </div>
          <div className="stat-card">
            <span>Number of spins</span>
            <span className="count-text">{spin?.spin_used}/{spin?.spin_available}</span>
          </div>
        </div>

        {/* Section 2: The Wheel */}
        <Turntable_spin_wheel />

        {/* Section 3: Icon Menu */}
        <div className="action-menu">
          <Link to={"/event-description"}>
            <div className="menu-item">
              <div className="icon-box ">
                <img
                  src="/assets/images/icons/Turntable_icon_1.png"
                  alt="icon"
                  className="Turntable_icon"
                />
              </div>
              <p>Event Description</p>
            </div>
          </Link>
          <Link to={"/activity-details"}>
            <div className="menu-item">
              <div className="icon-box ">
                <img
                  src="/assets/images/icons/Turntable_icon_2.png"
                  alt="icon"
                  className="Turntable_icon"
                />
              </div>
              <p>Event Details</p>
            </div>
          </Link>
          <Link to={"/activity-rules"}>
            <div className="menu-item">
              <div className="icon-box ">
                <img
                  src="/assets/images/icons/Turntable_icon_3.png"
                  alt="icon"
                  className="Turntable_icon"
                />
              </div>
              <p>Activity Rules</p>
            </div>
          </Link>
        </div>

        {/* Section 4: History Table */}
        <div className="history-section">
          <div className=" History_header">
            <div className="header-left">
              <span className="header_icon">
                <FontAwesomeIcon icon={faFileLines} />
              </span>
              <h4> History</h4>
            </div>
          </div>
          <div className="Game_History">
            <table className="table_wrapper">
              <thead>
                <tr>
                  <th>spin time</th>
                  <th>Reward type</th>
                  <th>prize</th>
                </tr>
              </thead>
              <tbody>
                {spinHistory?.data?.length > 0 ? (
                  spinHistory.data.map((item, index) => (
                    <tr key={index}>
                      <td>{formatNotifDate(item?.createdAt)}</td>
                      <td>Amount Reward</td>
                      <td>{formatAmount(item?.amount)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="no-data">
                      <No_data />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {spinHistory?.total_pages > 1 && (
              <CustomPagination
                currentPage={spinHistory?.current_page}
                totalPages={spinHistory?.total_pages}
                handlePageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>
    </section >
  );
}

export default Turntable;
